import { render } from "./HeaderBlockComponent.vue?vue&type=template&id=495568f8"
import script from "./HeaderBlockComponent.vue?vue&type=script&lang=js"
export * from "./HeaderBlockComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__